import React from 'react';
import FeedbackManager from '../components/admin/FeedbackManager';

/**
 * Pagina dedicata alla gestione dei feedback
 * Accessibile dalla sidebar dell'admin
 */
const FeedbackPage = () => {
  return <FeedbackManager />;
};

export default FeedbackPage;
